import { TopNavComponent } from '../shared';
import { SharedModule } from '../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RpwComponent } from './';
import { Ng2BootstrapModule } from 'ng2-bootstrap';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    BrowserModule,
    FormsModule,
    Ng2BootstrapModule.forRoot(),
    ReactiveFormsModule
  ],
  declarations: [RpwComponent],
  exports: [RpwComponent, TopNavComponent]
})

export class RpwModule { }



// WEBPACK FOOTER //
// ./src/app/resetPassword/rpw.module.ts